<template>
  <div id="controls">
    <transition name="fade">
      <div class="action" v-if="state == 'form'">
        <div class="btn btn-back" v-if="currentIndex > 0 && currentIndex < stepCount - 1">
          <a @click.prevent="controls('back')">{{ $t('message.controls.back')}}</a>
        </div>
        <div class="btn btn-next" v-if="currentIndex < stepCount - 1">
          <a @click.prevent="controls('next')">{{ $t('message.controls.next')}}</a>
        </div>
        <div class="btn btn-finish" v-if="currentStep == 'finalStep'">
          <a @click.prevent="controls('calculate')">{{ $t('message.controls.calculate')}}</a>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  props: ["currentIndex", "stepCount", "state", "currentStep"],
  methods: {
    controls(val) {
      this.$emit(val);
    },
  },
};
</script>

<style scoped>
#controls {
  margin-top: 3em;
  height: 80px;
  align-self: flex-end;
}

.btn {
  display: inline;
  margin: 0 15px;
}

.btn-next a::after {
  content: "〉";
  font-size: 25px;
  padding-left: 10px;
}
.btn-back a::before {
  content: "〈";
  font-size: 25px;
  padding-right: 10px;
}

a {
  cursor: pointer;
  color: #666;
  font-size: 2.2em;
  background: none;
  border: none;
  transition: 0.3s;
}

a:hover {
  color: #fff;
}

.btn-finish a {
  background-color: #3fa9f5;
  border-radius: 3px;
  color: #0d0d0d;
  padding: 7px 20px;
  transition: 0.3s;
}
.btn-finish a:hover {
  color: #fff;
}

@media only screen and (max-width: 768px) {
  a {
    font-size: 1.8em;
  }
}
</style>
